export default __webpack_public_path__ + "static/media/watx_token_img_re.0d62df2b.png";